import { useMemo } from 'react';

import {
  useWoopWorkloads,
  useWorkloadScalingPolicies,
} from 'features/workload-optimization';

export const useScalingPoliciesWithWorkloads = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const {
    workloads,
    isLoading: workloadsIsLoading,
    error: workloadsError,
  } = useWoopWorkloads({ enabled });

  const {
    policies: _policies,
    isLoading: policiesIsLoading,
    error: policiesError,
  } = useWorkloadScalingPolicies({ enabled });

  const policies = useMemo(() => {
    return workloads
      ? _policies?.map((p) => ({
          ...p,
          workloads: workloads.filter(
            ({ scalingPolicyId }) => p.id === scalingPolicyId
          ),
        }))
      : [];
  }, [_policies, workloads]);

  return {
    policies,
    isLoading: workloadsIsLoading || policiesIsLoading,
    hasError: !!workloadsError || !!policiesError,
  };
};
